import PropTypes from 'prop-types';
import React, { useState } from 'react';

import useToken from 'hooks/useToken';
import { Card /*, Modal ,Button*/ } from 'react-bootstrap';
import Notification from './Notificacion';

import { useEffect } from 'react';
import { FaChartBar } from 'react-icons/fa';
import Skeleton from 'react-loading-skeleton';
import SalesStatistic from '../SalesStatistic/SalesStatistic';
import ModalDesgloceVentas from './ModalDesgloceVentas/ModalDesgloceVentas';
import { useToast } from 'context/providers/ToastProvider';

const TarjetaVentasPorCategoria = ({
    idUsuario,
    dateQuarter,
    mes,
}) => {
    const { token, name, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [showModal, setShowModal] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [aviso, setAviso] = useState({});

    const ObtenerAvisos = async (idUsuario) => {
        setCargando(true);
        const response = await fetch("/api/home/ObtenerAvisos/?idUsuario=" + idUsuario, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {
            console.log("==== OBTENER AVISOS ====");
            console.log(response);
            const data = await response.json();
            console.log("OBTENER AVISOS", data);
            if (data['table1'][0].iResponseType == 1) {
                //Avisos
                setAviso(data['table2'][0]);
                console.log(data['table2'][0])
            }
            else {
                showErrorToast(data['table1'][0].vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);

    };

    useEffect(() => {
        ObtenerAvisos(idUsuario);
    }, [idUsuario])

    return (
        <>
            <Card>
                <Card.Header className="position-relative">

                    <div className="position-relative z-index-2">
                        <div>
                            <h3 className="text-primary mb-1">Hi! {name}</h3>
                            <div className="d-flex justify-content-between align-items-center">
                                <p className="text-800 mb-0">
                                    Here are your sales by category
                                </p>
                            </div>
                        </div>

                        <SalesStatistic
                            idUsuario={idUsuario}
                            mes={mes}
                        />

                        <div className="d-flex justify-content-end mt-2">
                            <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => setShowModal(true)}
                            >
                                <FaChartBar className="me-1" /> View Sales Details
                            </button>
                        </div>
                    </div>

                </Card.Header>
                <Card.Body className="p-0">
                    {cargando && <Skeleton />}
                    <ul className="mb-0 list-unstyled">
                        {aviso.vEmailIncorrecto > 0 &&
                            <Notification
                                title={"Tienes " + aviso.vEmailIncorrecto + " clientes con Email incorrecto."}
                                linkFor={"clientes"}
                                type={"warning"}
                                isLast={false}
                                link="/clientes/informacionincompleta/Email"
                            />
                        }
                        {aviso.vClientesDuplicados > 0 &&
                            <Notification
                                title={"Hay " + aviso.vClientesDuplicados + " contactos con tel&eacute;fono duplicado. Ayuda a filtrar o eliminar los contactos duplicados."}
                                linkFor={"contactos"}
                                type={"warning"}
                                isLast={false}
                                link="/clientes/contactosduplicados/TelefonoDuplicado"
                            />
                        }
                        {aviso.vTelefonoIncorrecto > 0 &&
                            <Notification
                                title={"Tienes " + aviso.vTelefonoIncorrecto + " contactos asignados con Tel\u00E9fono incorrecto."}
                                linkFor={"clientes"}
                                type={"warning"}
                                isLast={false}
                                link="/clientes/informacionincompleta/Telefono"
                            />
                        }
                        {aviso.vLatLonIncorrecto > 0 &&
                            <Notification
                                title={"Tienes " + aviso.vLatLonIncorrecto + " licencias activadas con Coordenadas incorrectas o repetidas. Edita la licencia y coloca las coordendas como corresponde."}
                                linkFor={"licencias"}
                                type={"warning"}
                                isLast={false}
                                link="/licencias/informacionincompleta/Coordenadas"
                            />
                        }
                        {aviso.vDireccionIncompleta > 0 &&
                            <Notification
                                title={"Tienes " + aviso.vDireccionIncompleta + " clientes con direcci&oacute;n incompleta."}
                                linkFor={"clientes"}
                                type={"warning"}
                                isLast={false}
                                link="/clientes/informacionincompleta/DireccionFiscal"
                            />}
                        {aviso.vUltimos48Horas > 0 &&
                            <Notification
                                title={"En las Ãºltimas 48 horas se conectaron >>>> <b>" + aviso.vUltimos48Horas + "</b> <<<< licencias de prueba asignadas a ti"}
                                linkFor={"licencias"}
                                isLast={false}
                                link="/licencias"
                            />
                        }
                        {aviso.vVendedorNoAsignado > 0 &&
                            <Notification
                                title={"Hay " + aviso.vVendedorNoAsignado + " licencias de prueba sin vendedor asignado"}
                                linkFor={"licencias"}
                                isLast={false}
                                link="/licencias"
                            />}
                    </ul>
                </Card.Body>
            </Card>

            {
                showModal &&
                <ModalDesgloceVentas
                    idUsuario={idUsuario}
                    dateQuarter={dateQuarter}
                    setShowModal={setShowModal}
                    showModal={showModal}
                />
            }
        </>
    );
};

TarjetaVentasPorCategoria.propTypes = {
    idUsuario: PropTypes.number,
    dateQuarter: PropTypes.instanceOf(Date),
    mes: PropTypes.instanceOf(Date)
};

export default TarjetaVentasPorCategoria;
